import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useForm, Controller } from "react-hook-form";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Skeleton } from "primereact/skeleton";
import CountryDropdown from "~/components/countryDropDown";

const LocationAddressForm = ({
  handleChange,
  data,
  states,
  cities,
  isLoading = false,
  isEdit,
  resetForm,
}) => {
  const {
    control,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: data,
  });
  useEffect(() => {
    if (resetForm) {
      reset(data);
    }
  }, [resetForm]);

  return (
    <div className="formgrid grid lsp-trading w-full">
      <div className="field col-12 md:col-12 sm:col-12">
        <label className="input-label mb-1">Address Line 1 *</label>
        {isLoading ? (
          <Skeleton className="p-4"></Skeleton>
        ) : (
          <Controller
            name="address_line_1"
            control={control}
            rules={{
              required: "Address is required.",
            }}
            render={({ field }) => (
              <InputText
                {...field}
                onChange={(e) => {
                  field.onChange(e);
                  handleChange("address_line_1", e.target.value);
                }}
                disabled={!isEdit}
                value={data?.address_line_1 || ""}
                type="text"
                placeholder="Street address"
                className={`input-field appearance-none outline-none w-full ${
                  errors?.address_line_1 ? "p-invalid" : ""
                }`}
              />
            )}
          />
        )}
        {errors?.address_line_1 && (
          <small className="p-error">{errors?.address_line_1?.message}</small>
        )}
      </div>

      <div className="field col-12 md:col-12 sm:col-12">
        <label className="input-label mb-1">Address Line 2</label>
        {isLoading ? (
          <Skeleton className="p-4"></Skeleton>
        ) : (
          <Controller
            name="address_line_2"
            control={control}
            render={({ field }) => (
              <InputText
                {...field}
                onChange={(e) => {
                  field.onChange(e);
                  handleChange("address_line_2", e.target.value);
                }}
                disabled={!isEdit}
                value={data?.address_line_2 || ""}
                type="text"
                placeholder="Apt, suite, unit, building, floor, etc."
                className={`input-field appearance-none outline-none w-full ${
                  errors?.address_line_1 ? "p-invalid" : ""
                }`}
              />
            )}
          />
        )}
      </div>
      <div className="field col-12 md:col-12 sm:col-12">
        <label className="input-label">Country *</label>
        {isLoading ? (
          <Skeleton className="p-4"></Skeleton>
        ) : (
          <Controller
            name="country"
            control={control}
            rules={{
              required: "Country is required.",
            }}
            render={({ field }) => (
              <CountryDropdown
                {...field}
                value={data?.country || {}}
                onChange={(e) => {
                  field.onChange(e.value);
                  handleChange("country", e.value);
                }}
                disabled={!isEdit}
                error={errors?.country}
                className={`w-full ${!isEdit && "dropdown-field"} ${!isEdit && "disable"} ${
                  errors.country ? "p-invalid" : ""
                }`}
              />
            )}
          />
        )}
        {errors?.country && (
          <small className="p-error">{errors?.country?.message}</small>
        )}
      </div>
      <div className="field input-item col-12 md:col-6">
        <label className="input-label">State/Province</label>
        {isLoading || data?.stateLoader ? (
          <Skeleton className="p-4"></Skeleton>
        ) : (
          <Controller
            name="state"
            control={control}
            render={({ field }) => (
              <Dropdown
                {...field}
                value={data?.state || ""}
                onChange={(e) => {
                  field.onChange(e.value);
                  handleChange("state", e.value);
                }}
                disabled={!isEdit}
                options={states}
                optionLabel="name"
                placeholder={"Select state/province"}
                checkmark={true}
                highlightOnSelect={false}
                className={`w-full ${!isEdit && "dropdown-field"} ${!isEdit && "disable"} ${
                  errors.country ? "p-invalid" : ""
                }`}
              />
            )}
          />
        )}
      </div>
      <div className="field input-item col-12 md:col-6">
        <label className="input-label">City</label>
        {isLoading || data?.cityLoader ? (
          <Skeleton className="p-4"></Skeleton>
        ) : (
          <Controller
            name="city"
            control={control}
            rules={{
              required: "City is required.",
            }}
            render={({ field }) => (
              <Dropdown
                value={data?.city || ""}
                onChange={(e) => {
                  handleChange("city", e.target.value);
                  field.onChange(e);
                }}
                disabled={!isEdit}
                options={cities}
                optionLabel="name"
                placeholder={"Select city"}
                checkmark={true}
                highlightOnSelect={false}
                name="city"
                className={`w-full ${!isEdit && "dropdown-field"} ${!isEdit && "disable"} ${
                  errors.country ? "p-invalid" : ""
                }`}
              />
            )}
          />
        )}
      </div>

      <div className="field col-12 md:col-12 sm:col-12">
        <label className="input-label mb-1">ZIP Code *</label>
        {isLoading ? (
          <Skeleton className="p-4"></Skeleton>
        ) : (
          <Controller
            name="postalcode"
            control={control}
            rules={{
              required: "Postal code is required.",
              pattern: {
                value: /^(?!\s*$)[a-zA-Z0-9]+( [a-zA-Z0-9]+)*$/,
                message: "Postal code must be numbers",
              },
            }}
            render={({ field }) => (
              <InputText
                {...field}
                onChange={(e) => {
                  field.onChange(e);
                  handleChange("postalcode", e.target.value);
                }}
                disabled={!isEdit}
                value={data?.postalcode || ""}
                type="text"
                placeholder="Enter ZIP Code"
                className={`input-field appearance-none outline-none w-full ${
                  errors?.postalcode ? "p-invalid" : ""
                }`}
              />
            )}
          />
        )}
        {errors?.postalcode && (
          <small className="p-error">{errors?.postalcode.message}</small>
        )}
      </div>
    </div>
  );
};
LocationAddressForm.propTypes = {
  states: PropTypes.array,
  handleChange: PropTypes.func,
  data: PropTypes.object,
  cities: PropTypes.array,
  isLoading: PropTypes.bool,
  isEdit: PropTypes.bool,
};
export default LocationAddressForm;
